import React, { useState } from 'react';
import Header from './Header';

function Navbar(){
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if(el){ el.scrollIntoView({behavior:'smooth', block:'start'}); }
  };
  return (
    <header className="nav">
      <div className="container nav-inner">
        <a href="#home" className="brand">Elegant <strong>Technologies FZ LLE</strong></a>
        <nav className="nav-links">
          {['home','about','services','testimonials','contact'].map(k => (
            <a key={k} href={'#'+k} onClick={e => {e.preventDefault(); scrollTo(k)}} className="nav-link">
              {k[0].toUpperCase()+k.slice(1)}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}

function Footer(){
  return (
    <footer className="footer">
      <div className="container">
        <div style={{display:'grid', gridTemplateColumns:'2fr 1fr 1fr', gap:24}}>
          <div>
            <h3 style={{marginTop:0}}>Elegant Technologies FZ LLE</h3>
            <p>Reliable software development and computer hardware services based in Fujairah.</p>
            <p style={{opacity:.8}}>Fujairah - Twin Towers P.O.Box 4422 Fujairah</p>
            <p style={{opacity:.8}}>Name: Bharat Meena</p>
            {/* <p style={{opacity:.8}}>Mobile: 9700007949 • Email: admin@godaraenterprises.com</p> */}
          </div>
          <div>
            <h4>Company</h4>
            <ul style={{listStyle:'none', padding:0, margin:0, lineHeight:'28px'}}>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div>
            <h4>Hours</h4>
            <p>Mon–Sat: 9:00 AM – 7:00 PM</p>
            <p>Sunday: Closed</p>
          </div>
        </div>
        <div style={{borderTop:'1px solid rgba(203,213,225,.2)', marginTop:16, paddingTop:16, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
          <small>© {new Date().getFullYear()} Elegant Technologies FZ LLE. All rights reserved.</small>
        </div>
      </div>
    </footer>
  );
}

function Hero(){
  return (
    <section id="home" className="hero" style={{backgroundImage:'url(https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1974&auto=format&fit=crop)'}}>
      <div className="container hero-inner">
        <h1 style={{fontSize:48, margin:'0 0 12px'}}>End-to-End IT Solutions</h1>
        <p style={{maxWidth:720, fontSize:18, lineHeight:1.7, opacity:.95}}>
          We provide modern software development, computer sales, custom PC builds, networking, and repair services.
          From idea to deployment and maintenance under one roof.
        </p>
        <div style={{marginTop:24, display:'flex', gap:12}}>
          <a href="#services" className="btn">Explore Services</a>
          <a href="#contact" className="btn">Get a Quote</a>
        </div>
      </div>
    </section>
  );
}

function Highlights(){
  const cards = [
    {title:'Custom Software', img:'https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1974&auto=format&fit=crop', desc:'Web apps, APIs, dashboards built with robust engineering practices.'},
    {title:'Hardware & PCs', img:'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?q=80&w=1974&auto=format&fit=crop', desc:'Branded desktops, custom rigs, upgrades, and peripherals.'},
    {title:'Networking', img:'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=1974&auto=format&fit=crop', desc:'Office setup, routers, structured cabling, and Wi-Fi optimization.'}
  ];
  return (
    <section className="section">
      <div className="container">
        <div className="grid grid-3">
          {cards.map((c,i)=>(
            <article key={i} className="card">
              <div style={{height:200, overflow:'hidden'}}>
                <img src={c.img} alt={c.title} className="img-cover" />
              </div>
              <div style={{padding:18}}>
                <h3 style={{marginTop:0}}>{c.title}</h3>
                <p className="small-muted">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

function About(){
  return (
    <section id="about" className="section">
      <div className="container">
        <div className="card" style={{overflow:'hidden'}}>
          <div style={{height:280, overflow:'hidden'}}>
            <img alt="Team collaborating" className="img-cover" src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1974&auto=format&fit=crop" />
          </div>
          <div style={{padding:24}}>
            <h2 className="section-title">About Elegant Technologies FZ LLE</h2>
            <p className="small-muted">
              Founded in Fujairah, we help individuals and SMBs with dependable IT solutions.
              We build modern web applications and also supply, install, and maintain computer hardware, networks, and accessories.
            </p>
            <p className="small-muted">
              Our mission is simple: deliver honest advice, quality workmanship, and responsive support.
              Whether it’s crafting a custom application or rescuing a PC at the last minute, our team is ready.
            </p>
            <div className="grid grid-3" style={{marginTop:8}}>
              {[
                {num:'150+', label:'Projects Delivered'},
                {num:'3000+', label:'Devices Repaired/Upgraded'},
                {num:'10+', label:'Years of Local Service'}
              ].map((k,i)=>(
                <div key={i} className="card" style={{padding:18, textAlign:'center'}}>
                  <div style={{fontSize:28, fontWeight:800}}>{k.num}</div>
                  <div style={{opacity:.7}}>{k.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Services(){
  const DATA = [
    { title:'Custom Web & Mobile Apps', points:['React, Node.js, Python','REST APIs & integrations','Admin dashboards & analytics'], img:'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?q=80&w=1974&auto=format&fit=crop' },
    { title:'Computer Sales & Assembly', points:['Branded desktops & laptops','Custom gaming/workstation builds','Upgrades: RAM, SSD, GPU'], img:'https://images.unsplash.com/photo-1512428559087-560fa5ceab42?q=80&w=1974&auto=format&fit=crop' },
    { title:'Repair & Maintenance', points:['OS install & cleanup','Chip-level troubleshooting','Data backup & recovery'], img:'https://plus.unsplash.com/premium_photo-1661960643553-ccfbf7d921f6?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2940' },
    { title:'Networking & CCTV', points:['LAN/WAN setup & cabling','Router, firewall, Wi-Fi optimization','Surveillance cameras & DVR/NVR'], img:'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=1974&auto=format&fit=crop' }
  ];
  return (
    <section id="services" className="section">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <div className="grid grid-2">
          {DATA.map((s,i)=>(
            <div key={i} className="card" style={{display:'grid', gridTemplateColumns:'1fr 1fr'}}>
              <div style={{height:220}}><img alt={s.title} src={s.img} className="img-cover" /></div>
              <div style={{padding:18}}>
                <h3 style={{marginTop:0}}>{s.title}</h3>
                <ul className="small-muted">{s.points.map((p,idx)=>(<li key={idx}>{p}</li>))}</ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Testimonials(){
  const DATA = [
    { quote:"They delivered our inventory web app exactly as promised. Smooth launch and great support.", name:"S. Reddy", role:"Retail Owner, Suryapet", avatar:"https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1080&auto=format&fit=crop" },
    { quote:"Got my workstation upgraded and the performance boost is amazing. Very professional.", name:"Anitha P.", role:"Graphic Designer", avatar:"https://images.unsplash.com/photo-1527980965255-d3b416303d12?q=80&w=1080&auto=format&fit=crop" },
    { quote:"They set up our office network and CCTV with neat cabling and clear documentation.", name:"V. Kumar", role:"Clinic Administrator", avatar:"https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=1080&auto=format&fit=crop" }
  ];
  return (
    <section id="testimonials" className="section">
      <div className="container">
        <h2 className="section-title">What Our Customers Say</h2>
        <div className="grid grid-3">
          {DATA.map((t,i)=>(
            <div key={i} className="card" style={{padding:18, display:'grid', gridTemplateColumns:'64px 1fr', gap:16, alignItems:'center'}}>
              <img src={t.avatar} alt={t.name} style={{width:64, height:64, objectFit:'cover', borderRadius:9999}}/>
              <div>
                <p className="small-muted" style={{margin:'6px 0'}}>&ldquo;{t.quote}&rdquo;</p>
                <div style={{fontWeight:700}}>{t.name}</div>
                <small style={{opacity:.7}}>{t.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Contact(){
  const [form, setForm] = useState({name:'', email:'', phone:'', subject:'', message:''});
  const [status, setStatus] = useState(null);
  const handleChange = (e) => setForm({...form, [e.target.name]: e.target.value});
  const handleSubmit = (e) => {
    e.preventDefault();
    if(!form.name || !form.email || !form.message){
      setStatus({ok:false, msg:'Please fill in Name, Email and Message.'}); return;
    }
    setStatus({ok:true, msg:'Thanks! Your message has been recorded. (Demo form — no backend configured)'});
    setForm({name:'', email:'', phone:'', subject:'', message:''});
  };

  return (
    <section id="contact">
      <section className="hero" style={{backgroundImage:'url(https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?q=80&w=1974&auto=format&fit=crop)'}}>
        <div className="container hero-inner">
          <h1 style={{fontSize:40, margin:'0 0 10px'}}>Contact Us</h1>
          <p style={{maxWidth:720}}>We’d love to hear about your project or device. Reach out and we’ll get back promptly.</p>
        </div>
      </section>
      <section className="section">
        <div className="container grid grid-2">
          <div className="card" style={{padding:22}}>
            <h3 style={{marginTop:0}}>Send a Message</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div>
                  <label htmlFor="name">Name</label>
                  <input id="name" name="name" value={form.name} onChange={handleChange} placeholder="Your name" />
                </div>
                <div>
                  <label htmlFor="email">Email</label>
                  <input id="email" name="email" type="email" value={form.email} onChange={handleChange} placeholder="you@example.com" />
                </div>
              </div>
              <div className="form-row" style={{marginTop:12}}>
                <div>
                  <label htmlFor="phone">Phone</label>
                  <input id="phone" name="phone" value={form.phone} onChange={handleChange} placeholder="+91 9XXXXXXXXX" />
                </div>
                <div>
                  <label htmlFor="subject">Subject</label>
                  <input id="subject" name="subject" value={form.subject} onChange={handleChange} placeholder="How can we help?" />
                </div>
              </div>
              <div style={{marginTop:12}}>
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" value={form.message} onChange={handleChange} placeholder="Tell us about your requirement..." />
              </div>
              <div className="form-actions">
                <button className="btn" type="submit">Send Message</button>
                {status && <small style={{color: status.ok ? 'green' : 'crimson'}}>{status.msg}</small>}
              </div>
            </form>
          </div>

          <div className="card" style={{padding:22, backgroundImage:'url(https://images.unsplash.com/photo-1526401281623-3599e1d5d43e?q=80&w=1974&auto=format&fit=crop)', backgroundSize:'cover', backgroundPosition:'center'}}>
            <div style={{background:'rgba(2,6,23,.65)', color:'white', padding:18, borderRadius:16}}>
              <h3 style={{marginTop:0}}>Our Address</h3>
              <p>Fujairah - Twin Towers P.O.Box 4422 Fujairah</p>
              <p><strong>Name:</strong>Bharat Meena<br/></p>
              {/* <strong>Mobile:</strong> 9700007949<br/> */}
              {/* <strong>Email:</strong> admin@godaraenterprises.com</p> */}
              <div style={{height:220, borderRadius:12, overflow:'hidden', marginTop:12}}>
                <iframe 
                  title="Map"
                  width="100%"
                  height="100%"
                  style={{border:0}}
                  loading="lazy"
                  allowFullScreen
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d57788.26571152158!2d56.326893500000004!3d25.143580299999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef4562899269769%3A0xba0627e5f8ea86e5!2sFujairah%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1763574812390!5m2!1sen!2sin"                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}

export default function App(){
  return (
    <div>
      <Header/>
      <Hero />
      <Highlights />
      <About />
      <Services />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
